import axios from "axios";

export const api = axios.create({
    baseURL: window.env.REACT_APP_ADMIN_API,
});

export const urlViaCep = axios.create({
    baseURL: window.env.REACT_APP_API_VIA_CEP,
});
